@let selectedReasonVal = selectedReason();

<tlc-churn-flow-step-template [currentStep]="2">
  <div class="left">
    <div class="heading-container">
      <span class="heading"
        >{{ 'tlc.churn_flow.steps.reasons.heading' | translate }}
        <rt-icon name="asterisk-new" colorToken="colorIconCriticalDefault" size="small-xxx" />
      </span>
    </div>
    <div class="reasons-container">
      @for (reason of churnFlowReasons; track $index) {
        <tlc-churn-flow-reason-selectable-card
          [label]="reason.label"
          [description]="reason.description"
          [iconName]="reason.iconName"
          (click)="selectReason(reason.id)"
          [isSelected]="selectedReasonVal === reason.id"
        />
      }
    </div>
    <div class="buttons-container">
      <rt-button variant="plain" (click)="stayWithTellent()"
        >{{ 'tlc.churn_flow.common.stay_with_tellent' | translate }}
      </rt-button>
      <rt-button variant="outline" [disabled]="!selectedReasonVal" (click)="navigateToReason()"
        >{{ 'tlc.churn_flow.steps.reasons.confirm' | translate }}
      </rt-button>
    </div>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
